import { Alert, Button, Divider, Group, Stack } from "@mantine/core";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import RuleNameEdit from "./RuleNameEdit";
import RuleDescription from "./RuleDescription";
import RuleDetailsPopup from "./RuleDetailsPopup/RuleDetailsPopup";
import { useRuleQuery } from "../../../../components/QueryBuilder/hooks/useRuleQuery";
import { useCanEdit } from "../../../../components/QueryBuilder/hooks/useCanEdit";
import {
  closeDetailsPopup,
  openDetailsPopup,
  useSelectDetailsPopupOpen,
} from "../../../../redux/features/ruleEditor/ruleEditorSlice";

/**
 * Top-of-page header for the RuleEditor. The Details modal is mounted
 * from here so it can read its own open/close from the slice without
 * prop-drilling through the page.
 */
export default function RuleEditorHeader({ ruleId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const detailsOpen = useSelectDetailsPopupOpen();
  const { data: rule } = useRuleQuery(ruleId);
  const canEdit = useCanEdit({ rule });

  if (!rule) return null;

  const isAdvancedSearch = rule.type === "ADVANCED_SEARCH";

  return (
    <Stack gap="sm" bg="gray.1" p="sm">
      <Group justify="space-between">
        {!isAdvancedSearch ? (
          <Button
            variant="filled"
            color="primary.7"
            onClick={() => dispatch(openDetailsPopup())}
          >
            Details
          </Button>
        ) : (
          <span />
        )}
        <Button variant="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      </Group>
      <Divider />

      <RuleNameEdit ruleId={ruleId} defaultName={rule.name} canEdit={canEdit} />
      <RuleDescription description={rule.description} />

      {rule.status === "ACTIVATED" && (
        <Alert color="yellow" variant="light">
          The rule is active and cannot be modified. Please deactivate it first
          in order to make changes.
        </Alert>
      )}

      <RuleDetailsPopup
        ruleId={ruleId}
        opened={detailsOpen}
        onClose={() => dispatch(closeDetailsPopup())}
      />
    </Stack>
  );
}
